import { motion } from 'framer-motion';
import { CountUp } from '../CountUp';
import { Users, Trophy, Flame, Clock } from 'lucide-react';

const STATS = [
  { icon: Users, end: 150, suffix: '+', label: 'Membres actifs' },
  { icon: Clock, end: 15, suffix: ' ans', label: "d'expérience coach" },
  { icon: Flame, end: 20, suffix: '+', label: 'Cours / semaine' },
  { icon: Trophy, end: 5, suffix: '', label: 'Programmes spécialisés' },
];

export const StatsStrip = () => {
  return (
    <section
      className="relative bg-dark overflow-hidden"
      data-testid="stats-strip"
    >
      <div className="absolute inset-0 mesh-gradient opacity-60" />
      <div className="absolute inset-0 grain-overlay" />

      <div className="container-custom relative z-10 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {STATS.map(({ icon: Icon, end, suffix, label }, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-10%' }}
              transition={{
                duration: 0.7,
                delay: idx * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="text-center md:text-left"
              data-testid={`stat-card-${idx}`}
            >
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-primary/15 border border-primary/30 mb-3">
                <Icon className="h-5 w-5 text-primary" strokeWidth={2.2} />
              </div>
              <div className="font-display text-5xl md:text-6xl text-white leading-none tracking-tight">
                <CountUp end={end} suffix={suffix} duration={2} />
              </div>
              <p className="text-white/55 text-xs md:text-sm mt-2 uppercase tracking-widest">
                {label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
